import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { LoginUserJoinForm } from './LoginUserJoinForm';

type MoveLoginPageFunction = () => void;

interface LoginUserInfoProps {
  userId: string;
  ceoName: string;
  storeName: string;
  userPhoneNumber: string;
  email: string;
  partnersId: string;
  moveLoginPage: MoveLoginPageFunction;
}

export const LoginUserJoinInfo = ({
  userId,
  ceoName,
  storeName,
  userPhoneNumber,
  email,
  partnersId,
  moveLoginPage,
}: LoginUserInfoProps) => {
  return (
    <Style>
      <div className="infoWrap">
        <div className="infoContent">
          <h3>아이디</h3>
          <h2>{userId}</h2>
          <h3>대표자명</h3>
          <h2>{ceoName}</h2>
          <h3>매장명</h3>
          <h2>{storeName}</h2>
          <h3>이메일</h3>
          <h2>{email}</h2>
          <h3>휴대폰 번호</h3>
          <h2>{userPhoneNumber}</h2>
          {partnersId !== '' && (
            <>
              <h3>등록 영업사</h3>
              <h2>{partnersId}</h2>
            </>
          )}
        </div>
        <div className="notice">회원가입이 완료되었습니다.</div>
        <button onClick={moveLoginPage} className="loginButton">
          <p>로그인 하기</p>
        </button>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  .infoContent {
    max-width: 100%;
    word-break: break-all;
  }
  h3 {
    margin-top: 24px;
    font-size: 14px;
    font-weight: 500;
    color: #4f5459;
  }
  h2 {
    margin-top: 6px;
    font-size: 20px;
    font-weight: 500;
    color: #26282c;
  }

  /* notice */
  .notice {
    margin-top: 24px;
    padding: 32px;
    border: 1px solid #d8dbdf;
    border-radius: 8px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #26282c;
  }

  /* loginButton */
  .loginButton {
    width: 100%;
    margin: 32px 0;
    padding: 12px 0;
    background: #26282c;
    border-radius: 8px;
    border: none;
    outline: none;

    p {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
    }
  }
`;
